import { useNav } from "../context/NavContext";

const TABS = [
  { id: "home",    icon: "🏠", label: "Home"    },
  { id: "profile", icon: "👤", label: "Profile"  },
];

export default function BottomTabBar() {
  const { screen, navigate } = useNav();
  const active = ["home"].includes(screen) ? "home" : screen === "profile" ? "profile" : "home";

  return (
    <nav style={styles.bar}>
      {TABS.map((tab) => {
        const isActive = active === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => navigate(tab.id)}
            style={{ ...styles.tab, color: isActive ? "#0ea5e9" : "rgba(255,255,255,0.4)" }}
          >
            <span style={styles.icon}>{tab.icon}</span>
            <span style={{ ...styles.label, fontWeight: isActive ? 600 : 400 }}>
              {tab.label}
            </span>
            {isActive && <div style={styles.dot} />}
          </button>
        );
      })}
    </nav>
  );
}

const styles = {
  bar: {
    position: "fixed",
    bottom: 0,
    left: "50%",
    transform: "translateX(-50%)",
    width: "100%",
    maxWidth: 480,
    display: "flex",
    background: "rgba(10,22,40,0.97)",
    borderTop: "1px solid rgba(255,255,255,0.09)",
    backdropFilter: "blur(16px)",
    zIndex: 50,
    padding: "8px 0 20px",
  },
  tab: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 3,
    background: "none",
    border: "none",
    cursor: "pointer",
    position: "relative",
    paddingTop: 6,
  },
  icon:  { fontSize: 22 },
  label: { fontSize: 11, letterSpacing: "0.03em" },
  dot: {
    position: "absolute",
    bottom: -4,
    width: 4,
    height: 4,
    borderRadius: "50%",
    background: "#0ea5e9",
  },
};
